// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1qjRm","selected":"Chip_selected__1JK7y"};